formatCheckoutV2OrderQuery